/* eslint-disable camelcase */
  <template >
  <div>
    <br>
  <div>
  <div class="formPosition">

<v-form
    ref="form"
    v-model="valid"
    lazy-validation
>
  <v-row>
    <template>
      <v-card style="margin:auto;" width="1200">
        <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="70"></v-progress-circular>
            </v-overlay>
        <v-container   style="background-color:#006699; color:white;border-bottom:1px solid white;">
      <div>
         <span>Painel de Renovação de Licença</span>
         <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs"
            v-on="on" style="float:right;color:white;">info
          </v-icon>
        </template>
        <span>Clique aqui para saber como criar um novo Produto</span>
      </v-tooltip>
      </div>
  </v-container>
   <v-alert
                      v-model="alert"
                      dismissible
                      :type="alertType"
                      border="left"
                      :icon="iconAlert"
                      transition="scale-transition"
                      :style="colorAlert"
                      elevation="2"
                      colored-border
                    >
                    {{msgAlert}}
                  </v-alert>
         <v-card-text>
            <v-row>
                <v-col md="12">
                   <span style="font-size:15px;font-weight:bold;">* Preencha os campos com a licença fornecida pelo proprietário do Software</span>
                </v-col>
            </v-row >
              <v-row style="border:1px solid #ccc;">
                <v-col md="1">
                  <v-text-field
                  type="text"
                  v-model="caixa1"
                  :rules="ruleLicenca"
                  style="font-size:30px;"
                  label=""
                  outlined
                  @keydown.enter="focusNext($event.target)"
                  ></v-text-field>
                </v-col>
                <v-col md="1">
                  <v-text-field
                  type="text"
                  v-model="caixa2"
                  :rules="ruleLicenca"
                  style="font-size:30px;"
                  label=""
                  outlined
                  @keydown.enter="focusNext($event.target)"
                  ></v-text-field>
                </v-col>
                <v-col md="1">
                  <v-text-field
                  type="text"
                  v-model="caixa3"
                  :rules="ruleLicenca"
                  style="font-size:30px;"
                  label=""
                  outlined
                  @keydown.enter="focusNext($event.target)"
                  ></v-text-field>
                </v-col>
                <v-col md="1">
                  <v-text-field
                  type="text"
                  v-model="caixa4"
                  :rules="ruleLicenca"
                  style="font-size:30px;"
                  label=""
                  outlined
                  @keydown.enter="focusNext($event.target)"
                  ></v-text-field>
                </v-col>
                <v-col md="1">
                  <v-text-field
                  type="text"
                  v-model="caixa5"
                  :rules="ruleLicenca"
                  style="font-size:30px;"
                  label=""
                  outlined
                  @keydown.enter="focusNext($event.target)"
                  ></v-text-field>
                </v-col>
                <v-col md="1">
                  <v-text-field
                  type="text"
                  v-model="caixa6"
                  :rules="ruleLicenca"
                  style="font-size:30px;"
                  label=""
                  outlined
                  @keydown.enter="focusNext($event.target)"
                  ></v-text-field>
                </v-col>
                <v-col md="1">
                  <v-text-field
                  type="text"
                  v-model="caixa7"
                  :rules="ruleLicenca"
                  style="font-size:30px;"
                  label=""
                  outlined
                  @keydown.enter="focusNext($event.target)"
                  ></v-text-field>
                </v-col>
                <v-col md="1">
                  <v-text-field
                  type="text"
                  v-model="caixa8"
                  :rules="ruleLicenca"
                  style="font-size:30px;"
                  @keydown.enter="focusNext($event.target)"
                  label=""
                  outlined
                  ></v-text-field>
                </v-col>
                <v-col md="1">
                  <v-text-field
                  type="text"
                  v-model="caixa9"
                  :rules="ruleLicenca"
                  style="font-size:30px;"
                  label=""
                  outlined
                  @keydown.enter="focusNext($event.target)"
                  ></v-text-field>
                </v-col>
                <v-col md="1">
                  <v-text-field
                  type="text"
                  v-model="caixa10"
                  :rules="ruleLicenca"
                  style="font-size:30px;"
                  @keydown.enter="focusNext($event.target)"
                  label=""
                  outlined
                  ></v-text-field>
                </v-col>
                <v-col md="1">
                  <v-text-field
                  type="text"
                  v-model="caixa11"
                  :rules="ruleLicenca"
                  @keydown.enter="focusNext($event.target)"
                  style="font-size:30px;"
                  label=""
                  outlined
                  ></v-text-field>
                </v-col>
                <v-col md="1">
                  <v-text-field
                  type="text"
                  v-model="caixa12"
                  :rules="ruleLicenca"
                  @keydown.enter="focusNext($event.target)"
                  style="font-size:30px;"
                    label=""
                   outlined
                  ></v-text-field>
                </v-col>
            </v-row>
         </v-card-text>
         <v-card-actions>
           <v-spacer></v-spacer>
            <v-btn color="green" style="color:white;" :disabled="!valid" @click="ValidarLicenca()">Validar Licença</v-btn>
         </v-card-actions>
      </v-card>
    </template>

  </v-row>
  </v-form>
  </div>
</div>
</div>
</template>
My CRUD
<script>

import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
import utilitarios from '../../plugins/utilitarios'
let generator = require('generate-password')
const ls = require('local-storage')
// const axios = require('../plugins/axios')
export default {
  directives: { mask },
  data: () => ({
    isLoading_: false,
    caixa1: '',
    caixa2: '',
    caixa3: '',
    caixa4: '',
    caixa5: '',
    caixa6: '',
    caixa7: '',
    caixa8: '',
    caixa9: '',
    caixa10: '',
    caixa11: '',
    caixa12: '',
    search: '',
    descricaoLicenca: '',
    licenca: '',
    menuFab: null,
    menuExp: null,
    valid: true,
    overlay: false,
    alert: false,
    iconAlert: '',
    alertType: '',
    colorAlert: '',
    msgAlert: '',
    y: 'top',
    ruleLicenca: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 1 || 'Apenas 1 Carácter'
    ]

  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Inser novo Estudante' : 'Editar dados de Estudante'
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      // eslint-disable-next-line no-undef
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      // eslint-disable-next-line no-undef
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },

    ListaActividades () {
      return ls.get('lista_actividades')
    },

    returnImagem () {
      return this.imageData
    },

    returnInstituicao () {
      return ls.get('i_id')
    }

  },

  watch: {
    menuFab (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menuExp (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    },
    model (val) {
      if (val.length > 1) {
        this.$nextTick(() => this.model.pop())
      }
    },
    search (val) {
      // Items have already been loaded
      if (val.length >= 4) {
      // Items have already been requested
        if (!this.produtos.filter(t => t.descricao.includes(val)).length) {
          this.produtos = []
          return this.initializeProdutos(val)
        }
      }

      if (val.length >= 4) { return this.initializeProdutos(val) }
    }

  },

  created () {

  },

  methods: {
    Continuar () {
      if (this.$refs.form.validate()) {
        this.tab = 1
      }
    },
    focusNexte (e) {
      const inputs = Array.from(e.target.form.querySelectorAll('input[type="text"]'))
      const index = inputs.indexOf(e.target)

      if (index < inputs.length) {
        inputs[index + 1].focus()
      }
    },

    showAlertSucess (msg) {
      this.alert = true
      this.tab = 0
      this.colorAlert = 'color:green;'
      this.iconAlert = 'done'
      this.alertType = 'success'
      this.msgAlert = msg
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },
    showAlertError (msg) {
      this.alert = true
      this.tab = 0
      this.colorAlert = 'color:red;'
      this.iconAlert = 'close'
      this.alertType = 'error'
      this.msgAlert = msg
      setTimeout(() => {
        this.alert = false
      }, 4000)
    },

    remover (indice) {
      this.contas.splice(indice, 1)
    },

    // METHODO FOR VALIDATION
    validate () {
      if (this.$refs.form.validate()) {

      } else {
        console.log('elso foraaa')
      }
    },
    reset () {
      this.$refs.form.reset()
      this.Limpar()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },

    async  ValidarLicenca () {
      if (this.$refs.form.validate()) {
        this.licenca = this.caixa1 + '' + this.caixa2 + '' + this.caixa3 + '' + this.caixa4 + '' + this.caixa5 + '' + this.caixa6 + '' + this.caixa7 + '' + this.caixa8 + '' + this.caixa9 + '' + this.caixa10 + '' + this.caixa11 + '' + this.caixa12
        this.overlay = true

        try {
          let msg = ''
          await axios({
            method: 'post',
            url: 'http://192.168.1.12:3000/api/renovarLicenca', //  http://relatorios.softlineangola.com
            data: {
              chave: this.licenca,
              instituicao: this.returnInstituicao
            }
          }).then(function (response) {
            msg = response
            console.log(response)
          })

          if (msg.data.mensagem === 'ok') {
            this.ActualizarDadosInstituicaoSlave(msg.data.dados)
          }
          if (msg.data.mensagem === 'erro') {
            this.showAlertError('Esta licença esta incorrecta')
            this.overlay = false
          }
        } catch (error) {
          this.overlay = false
          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
      }
    },
    async ActualizarDadosInstituicaoSlave (retorno) {
      let params = {
        tokenMaster: retorno.tokenMaster,
        dias: retorno.diasToken,
        dataExpiracao: retorno.dataExpiracao,
        instituicao: retorno.instituicao
      }
      try {
        let msg = await axios
          .post('/renovarSlave', params)
          .then(res => res.data)
        if (msg.affectedRows >= 1) {
          this.overlay = false
          this.showAlertSucess('A sua licença foi renovada com Sucesso')
          this.Limpar()
          this.text = 'Licença renovada com sucesso.'
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 3000 })
        }
      } catch (error) {
        this.text = error.message
      } finally {

      }
    },

    Limpar () {
      this.caixa1 = ''
      this.caixa2 = ''
      this.caixa3 = ''
      this.caixa4 = ''
      this.caixa5 = ''
      this.caixa6 = ''
      this.caixa7 = ''
      this.caixa8 = ''
      this.caixa9 = ''
      this.caixa10 = ''
      this.caixa11 = ''
      this.caixa12 = ''
    }

  }

}
</script>
<style scoped>

.btn_space {
  margin-bottom:5px;
}

.btn_add_align {
  margin-top:10px;
}
.file-upload-form, .image-preview {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    padding: 20px;
}
img.preview {
    background-color: white;
    border: 1px solid #DDD;
    padding: 5px;
}

</style>
